var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 113,
    viewBox: "0 0 150 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 138.751,
    height: 104.063,
    rx: 6,
    fill: "#F5F3F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 2.68629 13.6863 0 17 0H143.751C147.065 0 149.751 2.68629 149.751 6V15.1365H11V6Z",
    fill: "#FFAA38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6561 9.46023C22.7011 9.46023 23.5482 8.61313 23.5482 7.56818C23.5482 6.52322 22.7011 5.67612 21.6561 5.67612C20.6111 5.67612 19.764 6.52322 19.764 7.56818C19.764 8.61313 20.6111 9.46023 21.6561 9.46023Z",
    fill: "#FFCF9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9632 9.46023C29.0082 9.46023 29.8553 8.61313 29.8553 7.56818C29.8553 6.52322 29.0082 5.67612 27.9632 5.67612C26.9183 5.67612 26.0712 6.52322 26.0712 7.56818C26.0712 8.61313 26.9183 9.46023 27.9632 9.46023Z",
    fill: "#FFCF9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2699 9.46023C35.3148 9.46023 36.1619 8.61313 36.1619 7.56818C36.1619 6.52322 35.3148 5.67612 34.2699 5.67612C33.2249 5.67612 32.3778 6.52322 32.3778 7.56818C32.3778 8.61313 33.2249 9.46023 34.2699 9.46023Z",
    fill: "#FFCF9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3454 98.646L40.4937 56.6388C36.8222 50.4578 27.8722 50.4496 24.1957 56.6388L1.3452 98.646C-2.40805 104.962 2.136 112.96 9.49228 112.96H55.1964C62.5465 112.96 67.0986 104.968 63.3454 98.646ZM32.3447 105.379C30.2552 105.379 28.5543 103.678 28.5543 101.589C28.5543 99.4993 30.2552 97.7984 32.3447 97.7984C34.4342 97.7984 36.1351 99.4993 36.1351 101.589C36.1351 103.678 34.4342 105.379 32.3447 105.379ZM36.1351 90.2176C36.1351 92.3071 34.4342 94.008 32.3447 94.008C30.2552 94.008 28.5543 92.3071 28.5543 90.2176V71.2656C28.5543 69.1761 30.2552 67.4752 32.3447 67.4752C34.4342 67.4752 36.1351 69.1761 36.1351 71.2656V90.2176Z",
    fill: "#FE6E5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1543 62.4449C90.7329 62.4449 99.3086 53.8693 99.3086 43.2906C99.3086 32.712 90.7329 24.1364 80.1543 24.1364C69.5757 24.1364 61 32.712 61 43.2906C61 53.8693 69.5757 62.4449 80.1543 62.4449Z",
    fill: "#E3E0DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2999 37.7015C85.2999 40.3848 83.0948 42.5601 80.3747 42.5601C77.6546 42.5601 75.4495 40.3848 75.4495 37.7015C75.4495 35.0181 77.6546 32.8428 80.3747 32.8428C83.0948 32.8428 85.2999 35.0181 85.2999 37.7015ZM71.4478 53.7957C71.4478 48.9321 75.4445 44.9894 80.3747 44.9894C85.3049 44.9894 89.3017 48.9321 89.3017 53.7957H71.4478Z",
    fill: "#C3BDB6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 67.2335,
    width: 38.3086,
    height: 7.66172,
    rx: 2,
    fill: "#3F9BD5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailError);
export default __webpack_public_path__ + "static/media/email-error.9c1a0961b7b795a3c00b31f2e01031c2.svg";
export { ForwardRef as ReactComponent };